import {
    aqua,
    black,
    blue,
    error,
    gold,
    darkGold,
    green,
    info,
    lightGreen,
    lilac,
    orange,
    purple,
    red,
    success,
    warning,
    white,
    violet,
    yellow,
    lavender,
    lightViolet,
} from "./baseColors";
import { gradientProxy } from "./gradientProxy";
import { BasePalette } from "./palette.types";

export const basePalette: BasePalette = {
    primary: violet,
    white,
    black,
    blue,
    green: {
        200: lightGreen,
        600: green,
    },
    darkGold,
    gold,
    red,
    aqua,
    purple,
    lilac,
    lavender,
    orange,
    gradient: gradientProxy,
    status: {
        info,
        success,
        warning,
        error,
    },
    yellow,
    secondary: yellow,
    tertiary: lavender,
    lightViolet,
};
